module.exports = __webpack_public_path__ + "img/howto_step4_img.357180f5.png";